import router from "../router/index";
import store from "../store/index";
import { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

let logoutToastShown = false;

export const resetLogoutToastFlag = () => {
    logoutToastShown = false;
};

export const auth = function (response) {
    if (!response) return true;
    if (router.currentRoute.name === "Login") return true;
    if (response.errorCode !== "authentication_error") return true;
    if (!store.state.user.email) return true;
    
    if (logoutToastShown) return false;
    logoutToastShown = true;
    
    const $toast = useToast();
    $toast.error("You have been logged out. Please login to continue.", {
        position: 'top-right',
        duration: 5000,
        dismissible: true
    });
    
    store.commit("modals/resetState");
    
    store.dispatch("user/logout");
    return false;
};

const header = { "Content-type": "application/json; charset=UTF-8" };

export const get = async function (url) {
    try {
        url = process.env.VUE_APP_URL + url;
        let response = await fetch(url, {
            method: "GET",
            credentials: "include",
            headers: header,
        });
        response = await response.json();
        
        if (response.errorCode === "authentication_error") {
            auth(response);
            return [];
        }
        
        if (response.errorCode === "user_not_found") {
            store.dispatch("user/logout");
            return [];
        }
        
        if (response.errorCode === "trial_expired") {
            store.commit("modals/upgradeRequiredModal", true);
            return [];
        }
        
        if (response.status == 'error') return [];
        auth(response);
        return response;
    } catch (error) {
        console.error("GET request failed:", error);
        return [];
    }
};

export const put = async function (url, data) {
    url = process.env.VUE_APP_URL + url;
    let response = await fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        credentials: "include",
        headers: header,
    });
    
    if (!response.ok) {
        // Handle non-OK responses
        let errorData;
        try {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                errorData = await response.json();
                // Check for authentication errors even in error responses
                if (errorData.errorCode === "authentication_error") {
                    auth(errorData);
                    return errorData;
                }
                // Check for trial expired errors
                if (errorData.errorCode === "trial_expired") {
                    store.commit("modals/upgradeRequiredModal", true);
                    return errorData;
                }
            } else {
                // If it's not JSON (like HTML error page), create a structured error
                errorData = {
                    status: 'error',
                    message: `Server error: ${response.status} ${response.statusText}`,
                    statusCode: response.status
                };
            }
        } catch (parseError) {
            // If JSON parsing fails, create a structured error
            errorData = {
                status: 'error',
                message: `Server error: ${response.status} ${response.statusText}`,
                statusCode: response.status
            };
        }
        return errorData;
    }
    
    response = await response.json();
    
    if (response.errorCode === "trial_expired") {
        store.commit("modals/upgradeRequiredModal", true);
        return response;
    }
    
    auth(response);
    return response;
};


export const post = async function (url, data) {
    url = process.env.VUE_APP_URL + url;
    let response = await fetch(url, {
        method: "POST",
        body: JSON.stringify(data),
        credentials: "include",
        headers: header,
    });
    
    if (!response.ok) {
        // Handle non-OK responses
        let errorData;
        try {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                errorData = await response.json();
                // Check for authentication errors even in error responses
                if (errorData.errorCode === "authentication_error") {
                    auth(errorData);
                    return errorData;
                }
                // Check for trial expired errors
                if (errorData.errorCode === "trial_expired") {
                    store.commit("modals/upgradeRequiredModal", true);
                    return errorData;
                }
            } else {
                // If it's not JSON (like HTML error page), create a structured error
                errorData = {
                    status: 'error',
                    message: `Server error: ${response.status} ${response.statusText}`,
                    statusCode: response.status
                };
            }
        } catch (parseError) {
            // If JSON parsing fails, create a structured error
            errorData = {
                status: 'error',
                message: `Server error: ${response.status} ${response.statusText}`,
                statusCode: response.status
            };
        }
        return errorData;
    }
    
    let parsed;
    try {
        parsed = await response.json();
    } catch (parseErr) {
        return {
            status: 'error',
            message: 'Invalid response from server. Please try again.',
            errorCode: 'parse_error'
        };
    }
    response = parsed;
    
    if (response.errorCode === "trial_expired") {
        store.commit("modals/upgradeRequiredModal", true);
        return response;
    }
    
    auth(response);
    return response;
};

export const del = async function (url) {
    url = process.env.VUE_APP_URL + url;
    let response = await fetch(url, {
        method: "DELETE",
        credentials: "include",
        headers: header,
    });
    
    if (!response.ok) {
        // Handle non-OK responses
        let errorData;
        try {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                errorData = await response.json();
                // Check for authentication errors even in error responses
                if (errorData.errorCode === "authentication_error") {
                    auth(errorData);
                    return errorData;
                }
                // Check for trial expired errors
                if (errorData.errorCode === "trial_expired") {
                    store.commit("modals/upgradeRequiredModal", true);
                    return errorData;
                }
            } else {
                // If it's not JSON (like HTML error page), create a structured error
                errorData = {
                    status: 'error',
                    message: `Server error: ${response.status} ${response.statusText}`,
                    statusCode: response.status
                };
            }
        } catch (parseError) {
            // If JSON parsing fails, create a structured error
            errorData = {
                status: 'error',
                message: `Server error: ${response.status} ${response.statusText}`,
                statusCode: response.status
            };
        }
        return errorData;
    }
    
    response = await response.json();
    
    if (response.errorCode === "trial_expired") {
        store.commit("modals/upgradeRequiredModal", true);
        return response;
    }
    
    auth(response);
    return response;
};
export const validateEmail = function (email) {
    return /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email);
};
